
import { logger, dId, beautifyPrice } from "./utils";
import { json_vehicle, reservaD, IVA } from "./variables";
import { langDict } from "./dict";

declare const IMAGE_BASE: string;
declare const URL_BASE: string;


/** 
 * Control visibility of elements on results page. 
 * Should not be able to jump steps (3 always follows 2)
 * Scroll into view on each step.
 **/
function redrawDivs(i:number) {

  logger("Redraw divs: " + i, "log");

	const sec_divs : string[] = [

    "saveSearch", "searchAgain", "pricesChange",
    "filterGrid","resGrid", 
    "resDetail", "resIncluye","resSuplementos",
    "resDesglose","pagoPrevPrice",
    "resFormDiv", "resPayment", "resSaved"
   ];

  switch (i) {

    /**
     * Step 0: Start new search. 
     * Clear divs.Hide all contents beneath search form
     */
    case 0:

      hide_sections_all(sec_divs);
      reset_divs(["resDetail","resDesglose"]); 
      
      // focus element with smooth scroll: 
      (<HTMLElement>dId( "searchbox_wrapper" )).scrollIntoView(
        {behavior: "smooth", block: "start", inline: "nearest"}
      );

      break; 

    /**
     * Step 1: Show grid of results. Reset detalle section.
     * Move results box up for Android so some results are seen.
     * Clear divs. Hide all contents beneath search form
     */
    case 1:

      hide_sections_all(sec_divs);
      reset_divs(["resDetail","resDesglose","resPayment","resIncluye","resSups","resPayment"]);
      show_sections( ["resGrid", "filterGrid", "pricesChange", "saveSearch"] );

      // focus element with smooth scroll: 

      // if mobile width, scroll to top of results grid otherwise price change notice:
      if ( window.innerWidth < 768 ) {

        (<HTMLElement>dId( "search_results" )).scrollIntoView(
          {behavior: "instant", block: "start", inline: "nearest"}
        );
        
        (<HTMLElement>dId( "saveSearch" )).scrollIntoView(
          {behavior: "smooth", block: "start", inline: "nearest"}
        );
        
      } else {
        (<HTMLElement>dId( "pricesChange" )).scrollIntoView(
          {behavior: "smooth", block: "start", inline: "nearest"}
        );

      }
      

      break;

      
    /**
     * Step 2: Show 1 vehicle detail and price breakdown.
     * (hide grid, dont erase)  Show search again.
     **/
    case 2:

      hide_sections_all(sec_divs);
      show_sections( ["saveSearch", "searchAgain",  "resDetail", "resIncluye","resSuplementos",
                      "resDesglose","pagoPrevPrice"] );
      
      // focus element with smooth scroll: 
      (<HTMLElement>dId( "searchAgain" )).scrollIntoView(
        {behavior: "smooth", block: "start", inline: "nearest"}
      );

      break;



    /**
     * Step 3: Show payment buttons and customer details form
     * 
     **/
    case 3:
      
      hide_sections_all( ["resSaved", "resPayment"] );
      show_sections( ["resFormDiv"] );
      reset_divs(["resSaved", "resPayment"]);

      // focus element with smooth scroll: 
      (<HTMLElement>dId( "resFormDiv" )).scrollIntoView(
        {behavior: "smooth", block: "start", inline: "nearest"}
      );
      
      break;

   /**
     * Step 4: Connecting to GESEMAL - save reserva.
     * 
     **/
   case 4:
      
      show_sections( ["resSaved", "resPayment"] );

       // focus element with smooth scroll: 
       (<HTMLElement>dId( "resPayment" )).scrollIntoView(
        {behavior: "smooth", block: "start", inline: "nearest"}
      );

      break;



    /**
       * Step 5: Connecting to BANK. Show reservation saved message.
       * 
    **/
    case 5:
        
      show_sections( ["resPayment"] );
      break;


    default:

      logger("Invalid redrawDivs() call", "error");
      break;

  }

}


function hide_sections_all(sec_divs: string[]){

  sec_divs.forEach( (div) => {
    let e =  <HTMLElement>dId( div );
    if ( e ) {
     e.classList.add("hidden");
    }
  });

}

function show_sections(sec_divs: string[]){

  sec_divs.forEach( (div) => {
    let e =  <HTMLElement>dId( div );
    if ( e ) {
     e.classList.remove("hidden");
    }
  });

}

function reset_divs(divs: string[]){

  divs.forEach( (div) => {
    let e =  <HTMLElement>dId( div );
    if ( e ) {
     e.innerHTML = "";
    }
  });

}




/**
 * Step 1: Car Grid Elements (one per car - reordered on each result)
 * ! Should add CALCPRICE here and reduce code block TBD.
 */
function drawcargridNode (v: json_vehicle, i:number) {

  logger("Drawing one car grid node", "log");

  let grid = "";
  let kmmax = 99999;
  let kminc = v.kminc_gr;
  let kminc_text = "";
  let km_extra = "";
  let km_alt = ""; 
  let owtx = "";
  let chgow = 0.00;
  let cuota = v.cu * (1 + IVA);
  let on_request = '';
  let rvtog = "";
  let kmalt_css = "";
  let imgsrc = IMAGE_BASE + "vehiculos/sinFoto.jpg";


  let logosrc = IMAGE_BASE + "empresas-mail/" + v.agid + ".png"

  if (v.iurl.substring(0, 4) == "http") {
    imgsrc = v.iurl;
  } else {
    imgsrc = IMAGE_BASE + "vehiculos/" + v.iurl;
  }


  // ! never? used
  if (v.af_iurl !== null && v.af_iurl !== 0 ) {
    imgsrc = "https://www.autofurgo.com/media/com_epctracker/images/autos/" + v["af_iurl"]
  }
    
  // include kmmax for manual prices. 2021-11
   if ( v.kmmax !== null ) {
    kmmax = v.kmmax;
  }

  // Km extra info (2020-07)
  if ( v.km_extra != null ) {
    km_extra = "Km Extra: " + String(v.km_extra).substring(0,4) + "€/km";
  } else {
    km_extra = "&nbsp;";
  }
   
  
  // if less than 1000 then daily rate, otherwise full rental rate:
  if (kminc !== null && kminc <= 999) {	
    kminc = kminc*reservaD[5];
  } else if (kminc == null ) {
    kminc = kmmax;
  }

  if (kminc > kmmax){
    kminc = kmmax;
  }
  
  if (kminc >= 99999) {
    kminc_text = "<strong>" + langDict[91] + "</strong><span> </span>";
  } else {
    kminc_text = "<strong>" + Math.floor(kminc) + "<span>km</span></strong><span>" + km_extra + "</span>";
  }
  
  if (v.km_alt != null && v.km_alt !="") {
    km_alt = "<p class='km-alt'><em>" + langDict[90] + "</em></p>";
    // km_alt += "<span class='km-alt'>" + String(v.km_alt) + "</span>";
    // kmalt_css =  " km-alt-node ";
  } else {
    km_alt = "<p>&nbsp;</p>";
  }

  // Card and Agencia Logos: 
  const fpago = "<img src = '" + IMAGE_BASE + "layout/cards" + v["formapago"] + langDict[92] + ".png'>";
  // Not used: 
  const imgprov = IMAGE_BASE + "empresas/" + v["agid"] + ".png";


  // Revendor toggle (to hide certain results?
  // !Check if used: Maybe only rentoauto (revendors)
  if ( v.rvtoggle != null ) {
    rvtog = v.rvtoggle;
  } else {
    rvtog = "";
  }


  // One way fee show: 
  if (reservaD[8] == 1 && v.cuotaoneway  != null) {
    chgow = (v.cuotaoneway * (1 + IVA));
    owtx = " + OneWay: " + chgow.toFixed(2) + "€"
  } 
  
  // Formatted prices for display: 
  const fPrice = beautifyPrice( cuota * reservaD[5] + chgow);
  const dias = reservaD[5] == 1 ? " 1 " + langDict[93] : reservaD[5] + langDict[93] + "s ";
  
  if (typeof v["statuscode"] != "undefined" && v["statuscode"] == "R") {

    on_request = `<div class='tooltip'>
      <span style='color:red;font-weight:700'>${langDict[95]}</span>
        <img src='${URL_BASE}img/info.svg' alt='on request'>
        <span class='tooltiptext'>${langDict[94]}</span>
      </div>`;

  }

  let descD = ""; 
  // Add IDs to be able to close divs: 
  if (v.desc_ESP_D != null) {
    descD = v.desc_ESP_D.split("cgnhook").join( String(i) );
  }

    grid = `
    <div id='cgn_${i}' class='af-car-grid gnr-${v["idgrupo"]} ${kmalt_css} ${rvtog} '>
      <div class='cgn-flip'>

        <!-- card back -->
        <div class='card-back'>
          <span class='res-btn btn-sml card-close' data-toggle='${i}'>
            <img src='${URL_BASE}img/rotate.svg' alt='${langDict[101]}' class='icon-sml-invert'>
            ${langDict[101]}
          </span>
          <div class='despleg-close' id='desp_close_${i}'>
            <img src='${URL_BASE}img/close.svg' alt='${langDict[101]}' class='icon-input'>
          </div>
          <div class='despleg-buttons'>
            ${descD}
          </div>
        </div>

        <!-- card front -->
        <div class='card-front'>
          
          <section data-details='${i}'>
            <img src='${imgsrc}' title='(${v["grupo"]}) ${v["ve"]}' class='drivein-img'>
          </section>

          <section>
            <strong>${v["ve"]}</strong>
            <figure class='logo-img'><img src='${logosrc}' alt=''></figure>
            <span>${v["dimensiones"]}</span>
            ${on_request}
          </section>
          
          <section>
            <div class='precio'>
              <strong class='gridPrice'>${fPrice}</span></strong>
              <span>${langDict[100]} ${dias} ${langDict[97]}</span>
            </div>
            <div><!--divider--></div>
            <div class="kminc">
              ${kminc_text}
            </div>
          </section>

          <section>
             <span class='res-btn btn-sml btn-alt' data-toggle='${i}'>
              <img src='${URL_BASE}img/rotate.svg' alt='info' class='icon-sml-invert'>
              ${langDict[98]}
              </span>
            ${km_alt}
            ${fpago}
          </section>

          <section>
            <span class='res-btn btn-large' data-details='${i}'>${langDict[99]}</span>
          </section>

        </div>
        <!-- end card front -->
      </div>
      <!-- end flip -->
    </div>`;

    return grid;
  }



export { redrawDivs, drawcargridNode }


